module.exports = __webpack_public_path__ + "img/hr-diesel-locomotive-mask-4.a458ec4b.png";